import React from "react";
import { Link } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import { useState, useEffect, useContext } from "react";

//Import Context
import {AppContext} from '../../App'

//Import Css
import './tecnologia.css'

//Import Component
import MenuScrollBarComponent from "../menuScrollBarComponent/menuScrollBarComponent";
import {FooterComponent} from '../footerComponent/footerComponent';
import GalerieTechComponet from '../GalerieTechComponet/galerieTechComponent';

//Import Assets
import bannerTecnologiaParalax from '../../assets/tecnologiaAssets/PortadaTecnologia.jpg'
import logoMonitronix from '../../assets/homeAssets/logo-monitronix.svg'


export default function Tecnologia() {

    const {

    // Props Menu Bar Scroll Page
      linkUrl,
      nameClass,
      namePage,
      // Props Page Tecnología 
      bkGallerieTech,
      productTech

    } = useContext(AppContext); 


    // Background Portada Q somos 
    const isMobilePortadaTech = window.innerWidth <= 620;
    const styleBkBannerTecnologiaParalax = {
        backgroundImage: `url(${bannerTecnologiaParalax})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: "fixed",
        width: '100%',
        height: isMobilePortadaTech? '60vh' : '380px',
    }


    return(
        <div className="container-tecnologia-component">

            {/* // Sección menú scroll bar */}
            <div className="container-menu-component">

            <MenuScrollBarComponent 
            
                linkUrl1={linkUrl[0]}
                linkUrl2={linkUrl[1]}
                linkUrl3={linkUrl[2]}
                linkUrl4={linkUrl[4]}
    
                nameClass1={nameClass[0]}
                nameClass2={nameClass[1]}
                nameClass3={nameClass[2]}
                nameClass4={nameClass[4]}
                
                namePage1={namePage[0]}
                namePage2={namePage[1]}
                namePage3={namePage[2]}
                namePage4={namePage[4]}
            
            />

        </div>

        {/* // SECCIÓN BANNER TECNOLOGÍA */}
        <div className="banner-top-tech" style={styleBkBannerTecnologiaParalax}>

          <div className="box-text-tech">
            <h2 className="title-tech">TECNOLOGÍA</h2>
            <p className="text-slogan-tech">DE VANGUARDIA A TU CUIDADO</p>
          </div>

          <div className="box-logo-banner-monitronix">
            <img className="logo-banner-monitronix-tech" src={logoMonitronix}/>
          </div>

        </div>

            {/* SECCIÓN ANÁLOGOS */}
            <div className="container-tech-section container-tech-section-1">
          
                {/* Product - A */}
                <GalerieTechComponet
                  titleSectionTech={productTech[0].titleSectionTech}
                  textInfoTech={productTech[0].textInfoTech}
                  valorProductTech={0}
                  valorIndexBKGallerie={[0,1,2]}
                  valorTitlePanel={[0,1,2]}
                  valorTextInfoPanel={[0,1,2]}
                />

            </div>



            {/* SECCIÓN IP */}
            <div className="container-tech-section container-tech-section-2">
          
        
                {/* Product - B */}
                <GalerieTechComponet
                  titleSectionTech={productTech[1].titleSectionTech}
                  textInfoTech={productTech[1].textInfoTech}
                  valorProductTech={1}
                  valorIndexBKGallerie={[3,4,5]}
                  valorTitlePanel={[0,1,2]}
                  valorTextInfoPanel={[0,1,2]}
                />


            </div>


            {/* SECCIÓN INTELIGENTES */}
            <div className="container-tech-section container-tech-section-3">
          
        
                {/* Product - B */}
                <GalerieTechComponet
                  titleSectionTech={productTech[2].titleSectionTech}
                  textInfoTech={productTech[2].textInfoTech}
                  valorProductTech={2}
                  valorIndexBKGallerie={[6,7,8]}
                  valorTitlePanel={[0,1,2]}
                  valorTextInfoPanel={[0,1,2]}
                />


            </div>


              {/* // Seccion Footer */}
              <div className="footer-container-tech">
                  <FooterComponent />

              </div>


        </div>
    );
}